import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import CostObjectForm from "./CostObjectform";
import CostObjectEdit from "./CostObjectEdit";
import CostObjectTable from "./table";

function CostObjectPage() {
  const [dataVersion, setDataVersion] = useState(0);
  const [copiedData, setCopiedData] = useState<any>(null);
  const [isEditMode, setEditMode] = useState<boolean>(false);
  const [editedData, setEditedData] = useState<any>(null);

  useEffect(() => {
    console.log("this the copied data ", copiedData);
  }, [copiedData]);

  useEffect(() => {
    console.log("dataVersion updated:", dataVersion);
  }, [dataVersion]);

  return (
    <>
      <div>
        <div className="page-body">
          {isEditMode ? (
            <Container fluid>
              <div className="table-ad">
                <CostObjectEdit
                  dataVersion={dataVersion}
                  setDataVersion={setDataVersion}
                  isEditMode={isEditMode}
                  editedData={editedData}
                  setEditMode={setEditMode}
                  setCopiedData={setCopiedData}
                  setEditedData={setEditedData}
                />
              </div>
            </Container>
          ) : (
            <Container fluid>
              <div className="table-ad">
                <CostObjectForm
                  dataVersion={dataVersion}
                  setDataVersion={setDataVersion}
                  copiedData={copiedData}
                />
              </div>
            </Container>
          )}

          <CostObjectTable
            dataVersion={dataVersion}
            setDataVersion={setDataVersion}
            setCopiedData={setCopiedData}
            setEditMode={setEditMode}
            setEditedData={setEditedData}
          />
        </div>
      </div>
    </>
  );
}

export default CostObjectPage;